module.exports = __webpack_public_path__ + "img/tsy.eed0ac7f.png";